import { Button } from "@octopusdeploy/design-system-components";
import type { TimelineItem, LiveStatusSummaryResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { LiveStatusRow } from "./LiveStatusRow";
import { TimelineRow } from "./TimelineRow";
import { loadMoreButton, timeline } from "./styles";
interface TimelineProps {
    spaceId: string;
    projectId: string;
    environmentId: string;
    tenantId?: string;
    timelineData: TimelineItem[];
    loadMore: () => void;
    hasMore: boolean;
    liveStatusSummary: LiveStatusSummaryResource | null;
}
const NoLiveStatus = <></>;
export const Timeline = (props: TimelineProps) => {
    const getLiveStatusItem = (liveStatusSummary: LiveStatusSummaryResource) => {
        return liveStatusSummary.Status !== "NotSupported" ? (<li key="liveStatusRow">
                <LiveStatusRow summary={liveStatusSummary} {...props}/>
            </li>) : (NoLiveStatus);
    };
    return (<>
            <ul className={timeline}>
                {props.liveStatusSummary ? getLiveStatusItem(props.liveStatusSummary) : NoLiveStatus}
                {props.timelineData.map((tli) => (<li key={tli.Id}>
                        <TimelineRow item={tli}/>
                    </li>))}
            </ul>
            <div className={loadMoreButton}>{props.hasMore && <Button onClick={props.loadMore} label="Load More" importance="tertiary"/>}</div>
        </>);
};
